import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $close: this.el._$('.alert-component__close'),
      cookieName: this.el.dataset.cookieName
    }
    this.checkCookie();
  }

  addListeners() {
    this.dom.$close?._on('click', this.handleClose.bind(this));
  }

  handleClose() {
    this.dom.$el.classList.remove('active');
    this.setCookie(this.dom.cookieName, true, 365)
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    const expires = `expires=${ d.toUTCString()}`;
    document.cookie = `${cname  }=${  cvalue  };${  expires  };path=/`;
  }

  getCookie(cname) {
    const name = `${cname  }=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  checkCookie() {
    const cookie = this.getCookie(this.dom.cookieName);
    if (cookie.length === 0) {
      this.dom.$el.classList.add('active');
    }
  }
}

export default Module;
